













































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeMotivoRecusaOrcamentoStore from '@/components/Backoffice/Store/BackofficeMotivoRecusaOrcamentoStore'
import { permissionService } from '@/services/permission.service'
import { useHospitais } from '@/composables'
import _ from 'lodash'

@Component
export default class ViewBackofficeMotivoRecusaOrcamento extends Vue {
  loadHospital: boolean = false
  loadMotivoRecusaOrcamentoList: boolean = false

  get getBackofficeMotivoRecusaOrcamentoStore() {
    return getModule(BackofficeMotivoRecusaOrcamentoStore, this.$store)
  }

  get loadingMotivoRecusaOrcamentoList() { return this.loadMotivoRecusaOrcamentoList }
  set loadingMotivoRecusaOrcamentoList(value: boolean) { this.loadMotivoRecusaOrcamentoList = value }

  get loadingHospital() { return this.loadHospital }
  set loadingHospital(value: boolean) { this.loadHospital = value }
  get hospitalId() { return this.getBackofficeMotivoRecusaOrcamentoStore.hospitalId }
  set hospitalId(value: string) { this.getBackofficeMotivoRecusaOrcamentoStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map(h => (
      {
        id: _.toUpper(h.id),
        nome: _.toUpper(h.nome),
      }
    ))
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get motivoRecusaOrcamentoHeaders() {
    return [
      { text: 'Descrição', value: 'descricao', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get searchMotivoRecusaOrcamento() { return this.getBackofficeMotivoRecusaOrcamentoStore.searchMotivoRecusaOrcamento }
  set searchMotivoRecusaOrcamento(value: string) { this.getBackofficeMotivoRecusaOrcamentoStore.setSearchMotivoRecusaOrcamento(value) }

  async hospitalChange(id: any) {
    this.getBackofficeMotivoRecusaOrcamentoStore.setSearchMotivoRecusaOrcamento('')
    this.getBackofficeMotivoRecusaOrcamentoStore.setHospitalId(id)

    this.loadingHospital = true
    await this.getBackofficeMotivoRecusaOrcamentoStore.getMotivoDeRecusaDoOrcamentoByHospitalId()
    this.loadingHospital = false
  }

  get motivoRecusaOrcamentoList() {
    return this.getBackofficeMotivoRecusaOrcamentoStore.motivoRecusaOrcamentoList
  }

  get hasPermissionToEditResources() {
    return permissionService.hasPermission('agendamento.backoffice.recusaDeOrcamento.alterar')
  }

  adicionarMotivoRecusaOrcamento() {
    this.getBackofficeMotivoRecusaOrcamentoStore.setMode('CREATE')
    this.getBackofficeMotivoRecusaOrcamentoStore.clearMotivoRecusaOrcamento()
    this.getBackofficeMotivoRecusaOrcamentoStore.setModal({ name: 'motivoRecusaOrcamento', value: true })
  }

  editarMotivoRecusaOrcamento(item: any) {
    this.getBackofficeMotivoRecusaOrcamentoStore.setMode('EDIT')
    this.getBackofficeMotivoRecusaOrcamentoStore.setMotivoRecusaOrcamento({ ...item })
    this.getBackofficeMotivoRecusaOrcamentoStore.setModal({ name: 'motivoRecusaOrcamento', value: true })
  }

  beforeDestroy() {
    this.getBackofficeMotivoRecusaOrcamentoStore.clearMotivoRecusaOrcamentoList()
    this.getBackofficeMotivoRecusaOrcamentoStore.clearMotivoRecusaOrcamento()
    this.getBackofficeMotivoRecusaOrcamentoStore.setSearchMotivoRecusaOrcamento('')
    this.getBackofficeMotivoRecusaOrcamentoStore.clearHospitalId()
  }
}
